/*
 *  I01EVAECSQUALI2I18n.js
 *
 *  Created by Sébastien Hecart on 2017-12-10 13:48:32 +0000.
 *  Copyright © 2017 Sebastien Hecart. All rights reserved.
 *
 *
 */

export default {
  I01EVAECSQUALI2_SECTION_0_TITLE: "Calculez votre production d'eau chaude sanitaire collective en fonction de la méthode Qualitel.",
  I01EVAECSQUALI2_in_typeCalcul: '', //do not delete,required. auto generated code for empty title for segment
  I01EVAECSQUALI2_in_typeCalcul_0: 'Stockage ECS',
  I01EVAECSQUALI2_in_typeCalcul_1: 'Stockage primaire',
  I01EVAECSQUALI2_res_totalLogementStandard: 'Nombre de logements standards',
  I01EVAECSQUALI2_SECTION_1_TITLE: 'Simultanéïté retenue',
  I01EVAECSQUALI2_res_s1: 'Simultanéïté retenue S1',
  I01EVAECSQUALI2_res_s2: 'Simultanéïté retenue S2',
  I01EVAECSQUALI2_res_s3: 'Simultanéïté retenue S3',
  I01EVAECSQUALI2_res_simuDTU: 'Simultanéïté débit DTU',
  I01EVAECSQUALI2_SECTION_2_TITLE: 'Echangeur instantané',
  I01EVAECSQUALI2_in_tempFroide: 'Température Eau froide',
  I01EVAECSQUALI2_in_tempBouclage: 'Température eau chaude',
  I01EVAECSQUALI2_in_tempStackage: 'Température de stockage',
  I01EVAECSQUALI2_in_tempRetour: 'Température Retour Echangeur',
  I01EVAECSQUALI2_res_effEchangeur: 'Efficacité échangeur',
  I01EVAECSQUALI2_res_debitDTU: 'Débit minimum DTU',
  I01EVAECSQUALI2_res_puissMiniQualitel: 'Puissance mini Qualitel',
  I01EVAECSQUALI2_SECTION_3_TITLE: 'Stockage',
  I01EVAECSQUALI2_SECTION_3_TITLE2: "Stockage et puissance d'appoint",
  I01EVAECSQUALI2_res_modePuissance: 'Mode',
  I01EVAECSQUALI2_in_volume: 'Volume stockage',
  I01EVAECSQUALI2_res_puissance: 'Puissance échangeur',
  I01EVAECSQUALI2_in_volume2: 'Volume stockage',
  I01EVAECSQUALI2_res_puissance2: 'Puissance générateur',
  I01EVAECSQUALI2_p_inst: 'Puissance Instantanée',
  I01EVAECSQUALI2_couple_semi: 'Couple Semi-instantané',
  I01EVAECSQUALI2_couple_semiacc: 'Couple Semi-accumulé',
  I01EVAECSQUALI2_couple_acc: 'Couple à Accumulation',
  I01EVAECSQUALI2_couple_acc_prim: 'Couple à accumulation',
  I01EVAECSQUALI2_couple_semi_prim: 'Couple semi-instantané',
  I01EVAECSQUALI2_couple_semiacc_prim: 'Couple semi-accumulé'
}
